export const RESET = 'EXSBITEMTYPE_LIST_RESET'
export const SET_ITEMS = 'EXSBITEMTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBITEMTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBITEMTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBITEMTYPE_LIST_TOGGLE_LOADING'
